import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, Select, Space } from 'antd';
import { SAMPLE_MAP } from '../scripts/cy-constant';
import { cleanUpState, setSampleId, setTreeData } from '../scripts/tree-slice';

const SampleBtn = () => {
  const dispatch = useDispatch();
  const sampleId = useSelector((state) => state.tree.sampleId);

  const sampleOptions = [];

  sampleOptions.push({ value: '1', label: 'Mẫu 1: 4 đời - 15 người' });
  sampleOptions.push({ value: '2', label: 'Mẫu 2: 5 đời - 31 người' });
  sampleOptions.push({ value: '3', label: 'Mẫu 3: 6 đời - 35 người' });

  const sampleMap = {};
  for (let index = 0; index < sampleOptions.length; index++) {
    const option = sampleOptions[index];
    sampleMap[option.value] = option.label;
  }

  const initSample = () => {
    const sampleId = document.getElementById('sampleId').value;
    // debug-console.log('initSample: ', sampleId);
    const textUserData = SAMPLE_MAP[sampleId];
    // decrypted should be in Text, not Byte, because Thunk will reject
    dispatch(cleanUpState());
    dispatch(setTreeData(textUserData));
  };

  const onChangeSample = (value) => {
    // // debug-console.log('on change sample: ', value);
    Modal.confirm({
      title: `Dữ liệu hiện tại sẽ bị ghi đè, tiếp tục sử dụng "${sampleMap[value]}"?`,
      content: '',
      okText: 'Yes',
      cancelText: 'No',
      icon: null,
      centered: true,
      onOk() {
        document.getElementById('sampleId').value = value;
        dispatch(setSampleId(value));
        initSample();
      },
      onCancel() {},
    });
  };
  return (
    <Space direction="horizontal">
      <span>Chọn cây mẫu</span>
      {/* <GraphButton id="sample" label="Cây mẫu" onClick={initSample} className="btn-layout" /> */}
      <Select
        defaultValue={sampleId}
        showSearch
        style={{ width: 190 }}
        filterOption={(input, option) =>
          (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
        }
        onChange={onChangeSample}
        options={sampleOptions}
      />
      <input type="hidden" id="sampleId" name="sampleId" value="1" />
    </Space>
  );
};

export default SampleBtn;
